/**
 * Web override of `src/config.ts`.
 *
 * The web bundler resolves `.web.ts` ahead of `.ts` (web/rspack.config.js), so
 * every `import { API_URL } from '../config'` in the app gets this module in
 * the browser. Metro never sees `.web.*` files, so iOS and Android are
 * unaffected.
 *
 * Development: the dev server proxies `/__api` to the backend, so the browser
 * only ever makes same-origin calls and no CORS change is needed to run
 * locally. Production: same API host as the phone app; the backend CORS list
 * must include the web origin (docs/PLAN_web-app.md §4.3).
 */
import { API_URL as MOBILE_API_URL, CONFIG as MOBILE_CONFIG } from './config.js';

export * from './config.js';

export const WEB_DEV_API_PREFIX = '/__api';

const browserOrigin =
  (globalThis as unknown as { location?: { origin?: string } }).location?.origin ?? '';

// Production: FK_WEB_API_URL is set at build time (Cloudflare Pages
// environment variable, docs/RUNBOOK_web-launch.md) once the API has its
// custom domain; until then the phone's host is used.
const PRODUCTION_API_URL = (process.env.FK_WEB_API_URL || '').replace(/\/$/, '') || MOBILE_API_URL;

export const API_URL: string = __DEV__
  ? `${browserOrigin}${WEB_DEV_API_PREFIX}`
  : PRODUCTION_API_URL;

/** Build identity, for Sentry and analytics: finalkey-web@<commit>. */
export const WEB_RELEASE: string = process.env.FK_WEB_RELEASE || 'finalkey-web@dev';
/** 'development' | 'preview' | 'production'. */
export const WEB_ENVIRONMENT: string = process.env.FK_WEB_ENV || (__DEV__ ? 'development' : 'production');

export const CONFIG = {
  ...MOBILE_CONFIG,
  API_URL,
  IS_WEB: true,
};
